import React from "react";

import { styled } from '@mui/material/styles';

import PropTypes from "prop-types";
import { Divider, Drawer } from "@mui/material";

import SidebarNav from "./SidebarNav/SidebarNav";
import Profile from "./Profile/Profile";
import PrivacyPolicy from "../privacypolicy/PrivacyPolicyModal";

const PREFIX = 'Sidebar';

const classes = {
  drawer: `${PREFIX}-drawer`,
  root: `${PREFIX}-root`
};

const StyledDrawer = styled(Drawer)((
  {
    theme
  }
) => ({
  [`& .${classes.drawer}`]: {
    width: 240,
    [theme.breakpoints.up("md")]: {
      marginTop: 64,
      height: "calc(100% - 64px)",
    },
  },

  [`& .${classes.root}`]: {
    backgroundColor: theme.palette.white,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(2),
  }
}));

const Sidebar = (props) => {
  const { open, variant, onClose, className, ...rest } = props;



  return (
    <StyledDrawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={classes.root}>
        <Profile />
        <Divider />
        <SidebarNav />
        <div className="sidebarfooter">
          <div style={{ margin: "10px 0 0 0" }}>
            <p>
              <span>v{process.env.REACT_APP_VERSION}</span>
            </p>
          </div>
          <div>
            <PrivacyPolicy />
          </div>
        </div>
      </div>
    </StyledDrawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired,
};

export default Sidebar;
